import React from "react"
import { Content, TextContent } from "./Submit"
import { Page } from "./Page"
import { HeadingOne, Paragraph, Button } from "buoy-core"
import { ButtonRow } from "./ButtonRow"
import { pushRoute } from "../../common/route"
import { unmountBeforeUnload } from "../../common/common";

const redirectToSymptomChecker = () => {
  unmountBeforeUnload()
  return pushRoute("/symptom-checker/")
}

const TimedOut = () => (
  <Page>
    <Content>
      <TextContent>
        <HeadingOne>Your session has timed out</HeadingOne>
        <Paragraph>
          For your security, your session has timed out. Please start over.
        </Paragraph>
      </TextContent>
      <ButtonRow>
        <Button onClick={redirectToSymptomChecker}>
          Start Over
        </Button>
      </ButtonRow>
    </Content>
  </Page>
)

export { TimedOut as default }



// WEBPACK FOOTER //
// ./assets/payment/components/TimedOut.js